export default function(ngModule) {
    ngModule.factory('AddonProduct', function(Product) { return Product; });
    ngModule.factory('RequiredProduct', function(Product) { return Product; });
    ngModule.factory('OptionalProduct', function(Product) { return Product; });
    ngModule.factory('Product', function(BaseClass,$q, $http,EventDate, MetaData, sortByPredecessor, $translate, $log, $filter) {

        /**
         * Constructor function
         *
         * @constructor
         * @param {Object} attributes Initial attributes for the model
         */
        function Product(attributes) {
            _.assign(this,attributes);

            if(this.fees){
                let percentage = Number(Math.round(_.get(this, 'fees.self.percentages', 0) + _.get(this, 'fees.other.percentages', 0) + 'e2') / 100 + 'e-2');
                let fixed = _.get(this, 'fees.self.fixed', 0) + _.get(this, 'fees.other.fixed', 0);

                this.service_cost = _.toInteger(fixed);
                this.service_cost_percentage = percentage;
            }
            this.displayPrice = 0;
        }
        Product.modelName = 'Product';
        const prototype = {
            /* Configure a readable toString so we can echo it in i.e. ConfirmDelete  */
            toString() {
                return this.name;
            },
            get ticketPrice() {
                var ticketHasCustomProductPrice = _.isNumber(_.get(this, 'pivot.price'));
                var price = ticketHasCustomProductPrice ? this.pivot.price : this.price;
                return parseInt(price,10);
            },
            get nameWithPrice() {
                return `${ this.name } (${ $filter('formatCurrency')(this.ticketPrice) })`;
            },
            /**
             * Check if this is a tickets primairy product, containing price and metadata
             * @param {String} [guid] If you want to test for a specific ticket
             * @returns {Boolean} True if its a TicketProduct
             */
            isTicketProduct(guid = null) {
                let d = /^[\w]{8}(-[\w]{4}){3}-[\w]{12}$/;
                return this.name.indexOf('Product for ') === 0 &&
                    ( guid ? guid === this.description : d.test(this.description));
            },
            /**
             * Check if this is an event date's primairy product, containing price and metadata
             * @param {String} [guid] If you want to test for a specific event date
             * @returns {Boolean} True if its a TicketProduct
             */
            isAccessProduct(guid = null) {
                $log.warn('isAccessProduct is deprecated because naming convention changed with new wizard');
                let d = /^[\w]{8}(-[\w]{4}){3}-[\w]{12}$/;
                return d.test(this.description) &&
                    this.name.indexOf('Access for ') === 0 &&
                    (guid ? guid === this.description : true);
            },
            displayGlobalPrice(om) {
                let productPrice = this.price;
                // Container , insurance products etc
                if(this.pricing_method == 'container'){
                    // No product pricing used see; DD-API-271B
                    productPrice = 0;
                    if(this.service_cost_percentage > 0 || this.service_cost > 0) {
                        let varying = (om.orderTotalForGlobalProducts) * this.service_cost_percentage;
                        productPrice = _.toInteger(this.service_cost) + _.toInteger(varying);
                    }
                }
                else{
                    if(productPrice > 0) {
                        let varying = productPrice * this.service_cost_percentage;
                        productPrice += _.toInteger(this.service_cost) + _.toInteger(varying);
                    }
                }

                this.displayPrice = productPrice;
                return productPrice;
            }
        };
        for(let key of Object.keys(prototype)) {
            let descriptor = Object.getOwnPropertyDescriptor(prototype, key);
            descriptor.enumerable = false;
            Object.defineProperty(Product.prototype, key, descriptor);
        }

        BaseClass.apply(Product);

        Product.validates({
            name: {
                required: true
            },
            type: {
                inclusion: {
                    in: ['normal','varying']
                },
                required: true
            },
            price: {
                numericality: true
            },
            vat_percentage: {
                numericality: true,
                required: true,
                format: {
                    regex: {
                        regex: /\d{1,2}(?:[.,]\d{1,2})?/,
                        message: 'not a valid percentage'
                    }
                }
            },
            class: {
                requiredIf: {
                    requiredIf: function(value, instance, field) {
                        return instance.type === 'varying';
                    }
                },
                inclusion: {
                    in: ['bookingPeriod']
                }
            },
            description: {}
        });


        /* Product REST methods */
        Product.configureApi('/product/:guid', { queryAdmin: '/product/:status/:company', reinstate: '/product/:guid/reinstate' });
        Product.belongsToMany('EventDate','event_dates','/product/:guid/dates/^guid',[
            { type: 'query' },
            { type: 'attach' },
            { type: 'detach' }
        ]);

        Product.belongsToMany('MetaData','meta_data','/product/:guid/metaData/^guid',[
            {
                type: 'query',
                success: meta => sortByPredecessor(meta)
            },
            { type: 'attach' },
            { type: 'detach' },
            { type: 'reorder', url: '/product/:guid/metaData/reorder' }
        ]);

        Product.belongsToMany('Ticket','tickets','/product/:guid/tickets',[
            {
                type: 'query',
                success: tickets => sortByPredecessor(tickets)
            }
        ]);

        Product.belongsToMany('Ticket','tickets','/product/:guid/tickets',[{
            type: 'query',
            success: tickets => sortByPredecessor(tickets)
        }], 'Tickets');

        /* Automagically notify users if the following statii are returned from API */
        Product.configureAPIMessages({
            'POST /product/:product_guid/metaData/:guid': {
                406: 'models.product.notice.metaAlreadyAttached'
            },
            'DELETE /product/:product_guid/metaData/:guid': {
                406: 'models.product.notice.metaNotAttached'
            },
            'POST /shop/:shop_guid/products': {
                406: 'models.shop.notice.productAlreadyAssigned'
            },
            'DELETE /shop/:shop_guid/products': {
                406: 'models.shop.notice.productNotAssigned'
            },
            'POST /product/:product_guid/dates/:guid': {
                406: 'models.product.notice.dateAlreadyAttached'
            },
            'DELETE /product/:product_guid/dates/:guid': {
                406: 'models.product.notice.dateNotAttached'
            }
        });

        /**
         * Create a hidden product for eventDate.
         *
         * We hold a policy for only allowing 1 product per eventdate to
         * facilitate easier counting of sold tickets.
         *
         * This is a helper method to construct this product, setting name,
         * description and attaching the date
         *
         * @param {EventDate} eventDate An instance of eventDate
         * @return {Product} Promise that resolves with new product
         */
        Product.createForDate = function(eventDate) {
            let product = Product.new({
                name: 'Access for ' + eventDate.name,
                price: 0,
                type: 'normal',
                vat_percentage: 0,
                description: eventDate.guid
            });
            return product.$save().then(product => {
                return product.$attachEventDate(eventDate);
            }).then(() => {
                return product;
            });
        };


        /**
         * Find the hidden product for eventDate instance
         *
         * @param {EventDate} eventDate Instance of EventDate we want to query
         * @return {Product} Promise which resolves with product or rejects when none is found
         */
        Product.findForDate = function(eventDate) {
            return eventDate.$queryProduct().then(products => {
                var product;
                if(products.length) {
                    product = _.find(products, p => {
                        return p.description === eventDate.guid && p.name.indexOf('Access for ') === 0;
                    });
                    if(product)
                        return $q.resolve(product);
                }
                return $q.reject(new Error('Not Found'));
            });
        };

        return Product;
    });
}
